const isLocalPreviewHostname = (hostname) => {
  const normalized = String(hostname || '').trim().toLowerCase()
  return normalized === 'localhost' || normalized === '127.0.0.1' || normalized.endsWith('.localhost')
}

// UI policy uses the authenticated /me user, never the selected company or tenant.
// Dedicated historical HD endpoints enforce the production rule on the server.
// Local previews accept any valid authenticated email so restricted features can
// be exercised without weakening the production-domain gate.
export const canAccessHistoricalHd = (
  currentUser,
  hostname = typeof window !== 'undefined' ? window.location?.hostname : '',
) => {
  if (typeof currentUser?.email !== 'string') return false
  const parts = currentUser.email.trim().split('@')
  return parts.length === 2 && parts[0].length > 0 && !/[\s\x00-\x1f\x7f]/.test(parts[0])
    && !/[\s\x00-\x1f\x7f]/.test(parts[1]) && parts[1].length > 0
    && (parts[1].toLowerCase() === 'specific-ag.com' || isLocalPreviewHostname(hostname))
}
